import React from "react";
import { connect } from "react-redux";
import language from "../../../language/index.js";
import toastMessage from "../../../utils/toastMessage.js";
import api from "../../../utils/api/index.js";
import Button from "../../Button/Button.js";
import Modal from "../../Modal/Modal.js";
import { getStorage } from "../../../utils/storage.js";
import { fetchProductTypes } from "../../../utils/queries/productsType/index.js";
import icons from "../../../constants/icons.js";
import RespondRequest from "../requestForm/respondRequest.js";
import {
  deleteRequestedProducts,
  fetchRequestedProducts,
} from "../../../utils/queries/request-product.js";
import Table from "../../Table/Table.js";
import handleSearch from "../../../utils/handleSearch.js";
import NewRequest from "./NewRequest.js";
import { DeleteModal } from "../../Modal/index.js";
import ControlledTabs from "../../Tabs/Tabs.js";
import moment from "moment";
import { fetchPatientLabResult } from "../../../utils/queries/patient-lab-result.js";

const EXAM_UNITS = {
  HCT: "%",
  Hgb: "g/dL",
  "PLT Count": "×10³/μL",
};

let copyData = [];

class RequestedProduct extends React.Component {
  state = {
    error: {},
    data: [],
    csvData: [],
    packages: [],
    user: {},
    productInStock: [],
    currentStock: "",
    page: 1,
    limit: 50,
    selectedProduct: {},
    selectedData: {},
    showForwardModal: false,
    selectedForwardRequest: null,
    selectedForwardVolume: null,
    selectedDiagnosis: null,
    selectedDiagnosisTitle: null,
    selectedOtherDiagnosis: null,
    patientLabResults: [],
    delete_value: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
    this.getData(true);
  };

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  handleShowForwardModal = (forwardedRequest, volume, diagnosis, diagnosisTitle, otherDiagnosis) => {
    this.setState({
      showForwardModal: true,
      selectedForwardRequest: forwardedRequest || null,
      selectedForwardVolume: volume ?? null,
      selectedDiagnosis: diagnosis ?? null,
      selectedDiagnosisTitle: diagnosisTitle ?? null,
      selectedOtherDiagnosis: otherDiagnosis ?? null,
      patientLabResults: [],
    });

    const patientId = forwardedRequest?.patient?._id;
    if (patientId) this.fetchPatientLabResults(patientId);
  };

  fetchPatientLabResults = async (patientId) => {
    try {
      const result = await fetchPatientLabResult(this.props.defaultLanguage, {
        patient: patientId,
        page: 1,
        limit: 50,
      });
      if (!result) return;
      this.setState({ patientLabResults: result.data || [] });
    } catch (_) {}
  };

  canManageRequestProducts = () => {
    const { user } = this.state;
    const requestHospitalId = this.props.requestInfo?.hospital?._id;

    return (
      user.stock === this.props.stock ||
      (requestHospitalId &&
        user.hospital?._id?.toString() === requestHospitalId.toString())
    );
  };

  getData = async (isLoading) => {
    try {
      this.setState({ isLoading });
      const { request, defaultLanguage } = this.props;

      const { data, count, totalRecords } = await fetchRequestedProducts(defaultLanguage, {
        request,
        page: this.state.page,
        limit: this.state.limit,
      });
      console.log("Log here >>>>>>", data);
      this.setState({ isLoading: false, data, totalPageCount: count });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
      toastMessage("error", error);
    }
  };

  returnTableHeaders() {
    const isForwardFromNominative = this.state?.data?.some(
      (item) => item?.forwadedRequest?.patient
    );
    let headers = [
      {
        title: language[this.props.defaultLanguage].product,
        key: "productType.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      isForwardFromNominative && {
        title: language[this.props.defaultLanguage].patient_information,
        key: "forwadedRequest.patient.patientBBMSNumber",
        type: "link",
        onPress: (item) =>
          item?.forwadedRequest &&
          this.handleShowForwardModal(
            item.forwadedRequest,
            item.volume,
            item.diagnosis,
            item.diagnosisTitle,
            item.otherDiagnosis,
          ),
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
      },
      {
        title: `${language[this.props.defaultLanguage].volume} (ml)`,
        key: "volume",
      },
      {
        title: language[this.props.defaultLanguage].number_of_packages,
        key: "numberOfPackages",
      },
      {
        title: language[this.props.defaultLanguage].delivered_stock,
        key: "deliveredStock",
      },
    ].filter(Boolean);

    if (this.canManageRequestProducts()) {
      headers.push({
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      });
    }

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      let { defaultLanguage } = this.props;
      let { _id } = this.state.selectedData;

      await deleteRequestedProducts(defaultLanguage, { id: _id });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].delete_data_success,
      );

      this.setState({ isDeleting: false });

      this.handleCloseModal("showDeleteModal");
      this.getData(true);
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });

      toastMessage("error", error);
    }
  };

  getCurrentStock = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const allowedIds = (this.props.productType || []).map((el) =>
        typeof el === "object" ? el._id || el : el
      );

      const allTypes = await fetchProductTypes(this.props.defaultLanguage, {
        inputType: "dropdown",
      });

      const productTypes = (allTypes || [])
        .filter((el) => allowedIds.length === 0 || allowedIds.includes(el._id || el.value))
        .map((el) => ({
          label: el.label || el.name,
          value: el.value || el._id,
        }));

      this.setState({
        productInStock: productTypes,
        productTypes,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });

      toastMessage("error", error);
    }
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState(
      {
        [field]: e?.target ? e.target?.value : e,
        error,
      },
      () => {
        if (field === "productType" || field === "bloodGroup") {
          this.handleSearch();
        }
      },
    );
  }

  handleSearch() {
    const { productType, bloodGroup } = this.state;

    if (!bloodGroup || !productType) return;

    for (let el of copyData) {
      if (
        el.productType._id === productType.value &&
        bloodGroup.value === el.bloodGroup
      ) {
        this.setState({
          selectedProduct: el,
          requestStock: el.diff,
        });
      }
    }
  }

  validateForm() {
    let { error, productType, requestStock, bloodGroup } = this.state;

    if (!productType) {
      error.productType =
        language[this.props.defaultLanguage].product_type_required;
    }

    if (!requestStock) {
      error.requestStock =
        language[this.props.defaultLanguage].request_stock_required;
    }

    if (!bloodGroup) {
      error.bloodGroup =
        language[this.props.defaultLanguage].blood_group_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    try {
      let requiredBody = {},
        method = "POST",
        { selectedProduct, productType, bloodGroup, error } = this.state;

      await this.validateForm();

      if (Object.keys(error).length > 0) return;

      this.setState({ isSubmitting: true });

      requiredBody = {
        type: "bulk",
        request: this.props.request,
        productType: productType.value,
        numberOfPackages: selectedProduct.diff,
        bloodGroup: bloodGroup.value,
        toBeRequested: selectedProduct.diff,
      };

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/product-request`,
        data: requiredBody,
      };

      await api(options);

      this.setState({
        isSubmitting: false,
        selectedData: {},
        bloodGroup: null,
        currentStock: 0,
        requestStock: "",
        isRefresh: false,
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].data_added_success,
      );
      this.props.getData && this.props.getData();
    } catch (error) {
      this.setState({
        isSubmitting: false,
        selectedData: {},
        isRefresh: false,
      });

      toastMessage("error", error);
    }
  };

  handleNotifyReceiver = async () => {
    try {
      let method = "POST";

      this.setState({
        isSendingReminder: true,
      });

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/bloodRequest/notification`,
        data: {
          requestNo: this.props.requestInfo?.requestNo,
          origin: this.props.requestInfo?.hospital?.name,
        },
      };

      await api(options);

      this.setState({
        isSendingReminder: false,
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].notification_send_success,
      );
    } catch (error) {
      toastMessage("error", error);

      this.setState({
        isSendingReminder: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      },
    );
  }

  render() {
    const forwardedRequest = this.state.selectedForwardRequest;
    const forwardedPatient = forwardedRequest?.patient;
    const requestTypeLabels = {
      isOrdinary: language[this.props.defaultLanguage].ordinary,
      isUrgent: language[this.props.defaultLanguage].urgent,
      isEmergencyRelease: language[this.props.defaultLanguage].emergency_release,
    };
    const requestTypeLabel =
      requestTypeLabels[forwardedRequest?.requestType] ||
      forwardedRequest?.requestType ||
      "-";

    return (
      <>
        {}
        <div className="card" style={{ overflowY: "auto", maxHeight: "100vh" }}>
          <div className="card-header">
            <div className="d-flex gap-2">
              {this.props.status === "pending" &&
                this.canManageRequestProducts() && (
                  <>
                    <Button
                      text={
                        language[this.props.defaultLanguage].request_product
                      }
                      isSubmitting={this.state.isSubmitting}
                      onPress={() => this.handleShowModal("showToConfirm")}
                      icon={icons.add}
                    />
                    <Button
                      text={language[this.props.defaultLanguage].send_reminder}
                      isSubmitting={this.state.isSendingReminder}
                      onPress={() => this.handleNotifyReceiver()}
                      icon={icons.send}
                      className="btn-bordered btn-transparent"
                    />
                  </>
                )}

              {(this.state.user.role === "superAdmin" ||
                ((this.props.bloodBank?._id === this.state.user.stock ||
                  this.canManageRequestProducts()) &&
                  ["pending", "processing"].includes(this.props.status))) && (
                  <Button
                    text={language[this.props.defaultLanguage].add_shipment}
                    onPress={() => this.handleShowModal("showAddShipment")}
                    icon={icons.add}
                  />
                )}
            </div>
          </div>
          <div className="card-body">
            <Table
              isSearch
              handleSearch={(e) =>
                handleSearch(this, {
                  copyData,
                  value: e.target.value,
                })
              }
              search_text={this.state.search_text}
              data={this.state.data}
              page={this.state.page}
              limit={this.state.limit}
              handlePagination={this.handlePagination.bind(this)}
              totalPageCount={this.state.totalPageCount}
              totalRecords={this.state.totalRecords}
              isLoading={this.state.isLoading}
              headers={this.returnTableHeaders()}
              filters={[
                {
                  type: "button",
                  title: language[this.props.defaultLanguage].refresh,
                  button_type: "button",
                  icon: icons.refresh,
                  onPress: () => this.getData(true),
                },
              ]}
              actions={[
                this.props.status === "pending" && {
                  canAccess: true,
                  name: language[this.props.defaultLanguage].edit,
                  onPress: (item, index) =>
                    this.handleShowModal(
                      "showToConfirm",
                      language[this.props.defaultLanguage].delete_,
                      {
                        ...item,
                      },
                    ),
                },
                this.props.status === "pending" && {
                  canAccess: true,
                  name: language[this.props.defaultLanguage].delete_,
                  onPress: (item, index) =>
                    this.handleShowModal(
                      "showDeleteModal",
                      language[this.props.defaultLanguage].delete_,
                      {
                        ...item,
                      },
                    ),
                },
              ].filter(Boolean)}
            />
          </div>
        </div>
        <Modal
          show={this.state.showToConfirm}
          title={language[this.props.defaultLanguage].request_product}
          handleClose={() => this.handleCloseModal("showToConfirm")}
        >
          <NewRequest
            handleClose={() => this.handleCloseModal("showToConfirm")}
            {...this.props}
            getData={this.getData.bind(this, true)}
            selectedData={this.state.selectedData}
            data={this.state.data}
          />
        </Modal>

        <Modal
          show={this.state.showAddShipment}
          title={language[this.props.defaultLanguage].shipment}
          handleClose={() => this.handleCloseModal("showAddShipment")}
          size="lg"
        >
          <div className="card-body">
            {this.props?.requestInfo?._id && (
              <RespondRequest
                requestInfo={this.props.requestInfo}
                requestId={this.props.requestInfo?._id}
                requestNo={this.props.requestInfo?.requestNo}
                source={this.props.requestInfo?.bloodBank?._id}
                bloodBank={this.props.requestInfo?.hospital?.bloodBank}
                requestedProducts={this.state.data}
                handleClose={() => this.handleCloseModal("showAddShipment")}
              />
            )}
          </div>
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state?.selected_data?._id}
            getData={() => this.getData(true)}
          />
        </Modal>

        <Modal
          show={this.state.showForwardModal}
          title={language[this.props.defaultLanguage].request_information}
          handleClose={() => this.handleCloseModal("showForwardModal")}
          size="lg"
        >
          <div>
            <ControlledTabs
              options={[
                {
                  title:
                    language[this.props.defaultLanguage].nominative_request,
                  data: (
                    <div className="card-body">
                      <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {
                              language[this.props.defaultLanguage]
                                .request_number
                            }
                          </label>
                          <div>{forwardedRequest?.requestNo || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].hospital}
                          </label>
                          <div>{forwardedRequest?.hospital?.name || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].status}
                          </label>
                          <div>{forwardedRequest?.status || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].booking_date}
                          </label>
                          <div>
                            {forwardedRequest?.bookingDate
                              ? moment(forwardedRequest.bookingDate).format(
                                  "YYYY-MM-DD HH:mm",
                                )
                              : "-"}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {
                              language[this.props.defaultLanguage]
                                .sample_collected_date
                            }
                          </label>
                          <div>
                            {forwardedRequest?.sampleCollectionDate
                              ? moment(
                                  forwardedRequest.sampleCollectionDate,
                                ).format("YYYY-MM-DD HH:mm")
                              : "-"}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].blood_group}
                          </label>
                          <div>{forwardedRequest?.sampleBloodGroup || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].tested_date}
                          </label>
                          <div>
                            {forwardedRequest?.sampleTestedDate
                              ? moment(
                                  forwardedRequest.sampleTestedDate,
                                ).format("YYYY-MM-DD HH:mm")
                              : "-"}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].request_type}
                          </label>
                          <div>{requestTypeLabel}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].consented}
                          </label>
                          <div>
                            {forwardedRequest?.consent
                              ? language[this.props.defaultLanguage].yes
                              : language[this.props.defaultLanguage].no}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].requester_name}
                          </label>
                          <div>{forwardedRequest?.requestingDoctorName || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].requester_contact}
                          </label>
                          <div>{forwardedRequest?.requestingDoctorContacts || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].email_address}
                          </label>
                          <div>{forwardedRequest?.requestingDoctorEmail || "-"}</div>
                        </div>
                      </div>
                    </div>
                  ),
                },
                {
                  title:
                    language[this.props.defaultLanguage].patient_information,
                  data: (
                    <div className="card-body">
                      <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].BBMS_NUMBER}
                          </label>
                          <div>
                            {forwardedPatient?.patientBBMSNumber || "-"}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].patient_id}
                          </label>
                          <div>{forwardedPatient?.patientId || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].patient}
                          </label>
                          <div>
                            {forwardedPatient
                              ? `${forwardedPatient.firstName || ""} ${
                                  forwardedPatient.lastName || ""
                                }`.trim()
                              : "-"}
                          </div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].gender}
                          </label>
                          <div>{forwardedPatient?.gender || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].date_of_birth}
                          </label>
                          <div>{forwardedPatient?.dob || "-"}</div>
                        </div>
                      <div className="col-12 col-md-4 mb-3">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].contact}
                          </label>
                          <div>{forwardedPatient?.contact || "-"}</div>
                        </div>
                        <div className="col-md-4">
                          <label className="text-muted">
                            {
                              language[this.props.defaultLanguage]
                                .identity_number
                            }
                          </label>
                          <div>{forwardedPatient?.identityNumber || "-"}</div>
                        </div>
                        <div className="col-md-4">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].nationality}
                          </label>
                          <div>{forwardedPatient?.nationality || "-"}</div>
                        </div>
                        <div className="col-md-4">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].volume} (ml)
                          </label>
                          <div>
                            {this.state.selectedForwardVolume != null
                              ? this.state.selectedForwardVolume
                              : "-"}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <label className="text-muted">
                            {language[this.props.defaultLanguage].diagnosis}
                          </label>
                          <div>
                            {this.state.selectedDiagnosisTitle ||
                              this.state.selectedDiagnosis ||
                              "-"}
                          </div>
                        </div>
                        {this.state.selectedOtherDiagnosis && (
                          <div className="col-md-4">
                            <label className="text-muted">
                              {language[this.props.defaultLanguage].diagnosis}{" "}
                              (Other)
                            </label>
                            <div>{this.state.selectedOtherDiagnosis}</div>
                          </div>
                        )}
                      </div>
                      {this.state.patientLabResults.length > 0 && (
                        <div style={{ marginTop: "1rem" }}>
                          <label className="text-bold text-muted">
                            {"Lab Results"}
                          </label>
                          <table
                            className="table table-bordered"
                            style={{ marginTop: "0.5rem" }}
                          >
                            <thead>
                              <tr>
                                <th>Exam</th>
                                <th>Result</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.patientLabResults.map((r, i) => (
                                <tr key={i}>
                                  <td>{r.exam}</td>
                                  <td>
                                    {r.result || "-"}
                                    {r.result && EXAM_UNITS[r.exam] ? ` ${EXAM_UNITS[r.exam]}` : ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(RequestedProduct);
